import { apiClient } from '../client';
import type { SystemRole } from '@/types';

/**
 * Client for `/api/comms/members` (Stream E / ADR-027 §3.6). Stays in
 * lockstep with `server/src/routes/comms/members.routes.ts` +
 * `modules/comms/members.service.ts` — the lightweight org-transparent
 * picker directory (names + department + role only, no contact fields).
 *
 * Shared across comms surfaces (shout-out recipient picker, chat
 * participant picker). Consumed via the `['comms','members']` query.
 */

export interface CommsMember {
  membershipId: string;
  firstName: string;
  lastName: string;
  departmentId: string | null;
  role: SystemRole;
}

export async function listCommsMembers(): Promise<CommsMember[]> {
  const res = await apiClient.get<{ data: CommsMember[] }>('/api/comms/members');
  return res.data.data;
}
